import { Avatar } from '@mui/material';
import PropTypes from 'prop-types';
import { useGetProfileQuery } from '../features/api/rest/apiProfileSlice';

function ProfileAvatar({ size = 'small', previewPicture = null }) {
  const { profilePicture, username } = useGetProfileQuery(undefined, {
    selectFromResult: ({ currentData }) => ({
      profilePicture: currentData?.profile_picture,
      username: currentData?.username,
    }),
  });

  return (
    <Avatar
      data-testid="ProfileAvatar"
      imgProps={{ 'data-testid': 'ProfileAvatarImg' }}
      src={(previewPicture && URL.createObjectURL(previewPicture)) || profilePicture || ''}
      sx={{
        width: size === 'small' ? 40 : 150,
        height: size === 'small' ? 40 : 150,
        fontSize: size === 'small' ? 'auto' : 50,
      }}
    >
      {username?.charAt(0).toUpperCase()}
    </Avatar>
  );
}

ProfileAvatar.propTypes = {
  previewPicture: PropTypes.instanceOf(Blob),
  size: PropTypes.string,
};

export default ProfileAvatar;
